import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments';
import { PowerBIEmbeddedTokenDto } from '@models/webapi/dashboard.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  readonly #http = inject(HttpClient);
  readonly #webApiUrl = environment.apiConfig.baseUrl;
  private static readonly DASHBOARD_REPORT_ENDPOINT = '/powerbi/token';

  getConfig(dashboardType: string): Observable<PowerBIEmbeddedTokenDto> {
    const url = `${this.#webApiUrl}${DashboardService.DASHBOARD_REPORT_ENDPOINT}/${dashboardType}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.#http.get<PowerBIEmbeddedTokenDto>(url, { headers: headers });
  }

  setConfig(powerBIEmbeddedTokenDto: PowerBIEmbeddedTokenDto | null, tokenType: number): object {
    return {
      type: 'report',
      id: powerBIEmbeddedTokenDto?.id,
      embedUrl: powerBIEmbeddedTokenDto?.embedUrl,
      accessToken: powerBIEmbeddedTokenDto?.token,
      tokenType: tokenType,
      settings: {
        panes: {
          filters: {
            expanded: true,
            visible: false,
          },
        },
        bars: {
          statusBar: {
            visible: true,
          },
        },
        zoomLevel: 1.3,
      },
    };
  }
}
